/**
 * @generated SignedSource<<5344dc1a8e50e709a1255522659fab3b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserSyncEmailMutation$variables = Record<PropertyKey, never>;
export type UserSyncEmailMutation$data = {
  readonly syncUserEmail: {
    readonly __typename: "User";
  };
};
export type UserSyncEmailMutation = {
  response: UserSyncEmailMutation$data;
  variables: UserSyncEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSyncEmailMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "syncUserEmail",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserSyncEmailMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "syncUserEmail",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0a819d760ad17ad4f52b03baaa0a448",
    "id": null,
    "metadata": {},
    "name": "UserSyncEmailMutation",
    "operationKind": "mutation",
    "text": "mutation UserSyncEmailMutation {\n  syncUserEmail {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3e029a965f8e74105eeddc86d50447a";

export default node;
